import { useCallback } from 'react';
import {
	ChangeEventTypes,
	type OnChangeCallback,
} from '@atlassian/jira-issue-view-model/src/change-type.tsx';
import { useListViewUpdaterService } from '../list-view-updater/index.tsx';

export const useIssueChangeUpdater = () => {
	const { onIssueRemoved } = useListViewUpdaterService();

	const onIssueChange: OnChangeCallback = useCallback(
		(event) => {
			if (event.type === ChangeEventTypes.ISSUE_RELATIONSHIP_UPDATED) {
				const {
					issueId,
					meta: { oldParentIssueId },
				} = event;
				onIssueRemoved({
					issueId: Number(issueId),
					parentId: oldParentIssueId || undefined,
				});
			}
		},
		[onIssueRemoved],
	);

	return {
		onIssueChange,
	};
};
